import { useMemo } from 'react';
import { GetPrintSettings, GetPrintSettingsResponse } from '../api/dtos';

import { useGet } from '@ngt/forms';
import { SWRConfiguration, SWRResponse } from 'swr';


const getData = (response?: SWRResponse<GetPrintSettingsResponse, GetPrintSettingsResponse>) => response?.data;
const getError = (response?: SWRResponse<GetPrintSettingsResponse, GetPrintSettingsResponse>) => (response?.error ?? response?.data)?.responseStatus;

export const useGetPrintSettings = (
    configuration: SWRConfiguration = {
}) => {

    const request = useMemo(() => {
        return () => {
            return new GetPrintSettings();
        }
    }, []);

    return useGet(request, { getData, getError }, configuration)
}

export default useGetPrintSettings;